import styled from 'styled-components';

export const PresentationWrapper = styled.div`
    align-self: center;
    margin-top: 0.8rem;

    p {
        margin-bottom: 0.8rem;
        text-align: justify;
        text-indent: 5%;
    }

    h1 {
        margin-top: 3rem;
    }

    img {
        width: 100%;
        height: 100%;
    }
`;